module.exports = __webpack_public_path__ + "img/32.1c54f8f9.jpg";